import { createClient } from 'next-sanity'

import { apiVersion, dataset, projectId, useCdn, token } from '../env'

export const clientFetch = createClient({
  apiVersion,
  dataset,
  projectId,
  token,
  useCdn,
  perspective: 'published',
})

export async function client({ query, tags }) {
  return clientFetch.fetch(query, {
    cache: 'force-cache',
    next: { tags },
  })
}
